export function NeonButton({ children, onClick, testid, className = "" }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2 rounded-md bg-neon px-7 py-3.5 font-display text-sm font-bold uppercase tracking-wider text-ink transition-[box-shadow,transform] duration-300 hover:shadow-[0_0_32px_rgba(0,255,102,0.45)] active:scale-[0.98] ${className}`}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, onClick, testid, className = "" }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2 rounded-md border border-line bg-transparent px-7 py-3.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:border-neon/60 hover:text-neon active:scale-[0.98] ${className}`}
    >
      {children}
    </button>
  );
}
